import React, { useEffect, useState } from 'react';
import { TiArrowRightThick, TiArrowLeftThick } from "react-icons/ti";
import Card from './component/Card';
import AOS from 'aos';
import 'aos/dist/aos.css';

const BestSelling = ({ item, loading }) => {
  const [startIndex, setStartIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(1);
  const [isMobile, setIsMobile] = useState(false);

  const updateVisibleCount = () => {
    const width = window.innerWidth;
    setIsMobile(width < 640); 

    let newCount = 1;
    if (width >= 1536) newCount = 6;
    else if (width >= 1280) newCount = 5;
    else if (width >= 1024) newCount = 5;
    else if (width >= 768) newCount = 2;

    setVisibleCount(newCount);
    setStartIndex(prev => Math.min(prev, Math.max(item.length - newCount, 0)));
  };

  const handleNext = () => {
    const maxIndex = item.length - visibleCount;
    if (startIndex < maxIndex) {
      setStartIndex(prev => Math.min(prev + 1, maxIndex));
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(prev => Math.max(prev - 1, 0));
    }
  };

  useEffect(() => {
    AOS.init();
    updateVisibleCount();
    window.addEventListener('resize', updateVisibleCount);
    return () => window.removeEventListener('resize', updateVisibleCount);
  }, [item]);

  return (
    <div className="py-7 px-4 md:px-12 bg-Background3" >
      <div className="flex justify-between items-center">
        <span className="text-textColor text-lg md:text-3xl font-bold title">
          Best Selling Categories
        </span>

        {/* Arrows visible only on sm and up */}
        {!isMobile && (
          <div className="gap-4 sm:gap-6 text-3xl font-bold flex">
            <div
              className='bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer'
              onClick={handlePrev}
            >
              <TiArrowLeftThick />
            </div>
            <div
              className='bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer'
              onClick={handleNext}
            >
              <TiArrowRightThick />
            </div>
          </div>
        )}
      </div>

      {loading ? (
        <div className="mt-6 flex justify-center">
          <span className="loading loading-ring loading-xl"></span>
        </div>
      ) : (
        <div className={`mt-5 relative ${isMobile ? 'overflow-x-auto' : 'overflow-hidden'} scrollbar-hide`}>
          <div
            className={`flex gap-4 sm:gap-2 md:gap-2 lg:gap-8 transition-transform duration-300 ${
              isMobile ? 'flex-nowrap' : ''
            }`}
            style={{
              transform: isMobile ? 'none' : `translateX(-${startIndex * (100 / visibleCount)}%)`,
            }}
          >
            {item?.map((item, index) => (
              <div
                key={index}
                className={`pb-2 ${
                  isMobile
                    ? 'min-w-[100%]'
                    : 'min-w-[calc(100%/2)] sm:min-w-[calc(100%/1)] md:min-w-[calc(100%/2)] lg:min-w-[calc(100%/5)] xl:min-w-[calc(100%/5)] 2xl:min-w-[calc(100%/6)]'
                }`}
              ><div className="h-full flex">
                <Card item={item} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BestSelling;